function beforeScriptExecuteListener(evt) {
    if (node.getAttribute('type') === 'text/partytown') {
        evt.preventDefault();
    }
    node.removeEventListener(
        'beforescriptexecute',
        beforeScriptExecuteListener,
    );
}

(function () {
    try {
        var head = document.getElementsByTagName('head');
        if (!head) return;
        var targetNode = head[0];
        if (!targetNode) return;
        var config = { attributes: true, childList: true, subtree: false };

        // Define external tracking script patterns
        var externalTrackingPatterns = [/bat\.bing\.com/];

        var callback = (mutationList, observer) => {
            for (var mutation of mutationList) {
                if (mutation.type === 'childList') {
                    for (var addedNode of mutation.addedNodes) {
                        // Handle external tracking scripts
                        if (
                            addedNode.nodeType === 1 &&
                            addedNode.tagName === 'SCRIPT' &&
                            !addedNode.classList.contains('headobs-ignore') &&
                            addedNode.getAttribute('src')
                        ) {
                            var src = addedNode.getAttribute('src');
                            var isTrackingScript =
                                externalTrackingPatterns.some((pattern) =>
                                    pattern.test(src),
                                );
                            if (isTrackingScript) {
                                addedNode.type = window.Partydawn.settings
                                    .blockTrekkie
                                    ? 'text/blocked'
                                    : 'text/partytown';
                                addedNode.addEventListener(
                                    'beforescriptexecute',
                                    beforeScriptExecuteListener,
                                );
                            }
                        }

                        // Handle inline analytics scripts (existing logic)
                        if (
                            addedNode.nodeType === 1 &&
                            addedNode.tagName === 'SCRIPT' &&
                            !addedNode.classList.contains('headobs-ignore') &&
                            !addedNode.getAttribute('src') &&
                            addedNode.classList.contains('analytics')
                        ) {
                            addedNode.type = window.Partydawn.settings
                                .blockTrekkie
                                ? 'text/blocked'
                                : 'text/partytown';
                            if (window.Partydawn.settings.blockTrekkieFbPixel) {
                                addedNode.innerHTML =
                                    addedNode.innerHTML.replace(
                                        /,"Facebook Pixel":{"pixelIds":\["\d+"\],"agent":"[a-zA-Z0-9\.-_]+"}/,
                                        '',
                                    );
                            }
                            addedNode.addEventListener(
                                'beforescriptexecute',
                                beforeScriptExecuteListener,
                            );
                        }

                        // Handle ShopifyAnalytics scripts (existing logic)
                        if (
                            addedNode.nodeType === 1 &&
                            addedNode.tagName === 'SCRIPT' &&
                            !addedNode.classList.contains('headobs-ignore') &&
                            !addedNode.getAttribute('src') &&
                            !addedNode.classList.contains('analytics') &&
                            addedNode.textContent.includes('ShopifyAnalytics')
                        ) {
                            var firstScript =
                                document.getElementsByTagName('script')[0];
                            var newScript = document.createElement('script');
                            newScript.type = 'text/javascript';
                            newScript.classList.add('headobs-ignore');
                            newScript.text = addedNode.textContent;
                            firstScript.parentNode.insertBefore(
                                newScript,
                                firstScript,
                            );

                            addedNode.type = window.Partydawn.settings
                                .blockTrekkie
                                ? 'text/blocked'
                                : 'text/partytown';
                            addedNode.addEventListener(
                                'beforescriptexecute',
                                beforeScriptExecuteListener,
                            );
                        }
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    } catch (e) {
        console.error(e);
    }
})();
